import { render, staticRenderFns } from "./PCLayout.vue?vue&type=template&id=7c98fcd3&scoped=true"
import script from "./PCLayout.vue?vue&type=script&lang=js"
export * from "./PCLayout.vue?vue&type=script&lang=js"
import style0 from "./PCLayout.vue?vue&type=style&index=0&id=7c98fcd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c98fcd3",
  null
  
)

export default component.exports